import { css } from '@emotion/react';
import styled from '@emotion/styled';

// Container

interface ContainerProps {
  borderless?: boolean;
}

export const Container = styled.div<ContainerProps>`
  --card-layout-padding-vertical: 1.5rem;
  --card-layout-padding-horizontal: var(--card-layout-padding-vertical);

  --card-layout-content-padding-horizontal: 0;
  --card-layout-content-padding-vertical: 0;
  --card-layout-content-padding: var(--card-layout-content-padding-vertical)
    var(--card-layout-content-padding-horizontal);

  --card-layout-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.1);
  --card-layout-border-radius: 0.5rem;
  --card-layout-gap: 1rem;

  display: flex;
  // Preserve the aspect ratio of the card on grid layouts.
  // https://github.com/8base-services/jebel/issues/1433
  min-width: 0;
  flex-direction: column;
  gap: var(--card-layout-gap);
  background-color: ${p => p.theme.palette.background.paper};
  padding: var(--card-layout-padding-vertical) var(--card-layout-padding-horizontal);
  box-shadow: var(--card-layout-shadow);
  border-radius: var(--card-layout-border-radius);

  ${p =>
    p.borderless &&
    css`
      --card-layout-padding-horizontal: 0;

      --card-layout-content-padding-horizontal: 1rem;
      --card-layout-content-padding-vertical: 0;
      --card-layout-gap: 1rem;

      box-shadow: none;
      border-radius: initial;
    `}

  ${p => p.theme.breakpoints.down('sm')} {
    --card-layout-padding-vertical: 1rem;
  }
`;

// Content

export const Content = styled.div`
  padding: var(--card-layout-content-padding);
`;

// Footer

export const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: var(--card-layout-content-padding);
`;
